import FeedbackPage from '@/components/FeedbackPage'
import { getCommFeedback } from '@/utils/feedbackContent'

export default function CommFeedbackPage() {
  return <FeedbackPage {...getCommFeedback()} />
}
